import { render } from "./DefaultCover.vue?vue&type=template&id=00969756"
import script from "./DefaultCover.vue?vue&type=script&lang=js"
export * from "./DefaultCover.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__